module.exports = __webpack_public_path__ + "img/savanta-logo.7f178eae.svg";